const LoadingOverlay = () => {
  return <div className="loading-spinner" />;
};

export default LoadingOverlay;
